var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "47px",
    height: "33px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f4f6",
    d: "M -0.5,-0.5 C 15.1667,-0.5 30.8333,-0.5 46.5,-0.5C 46.5,10.5 46.5,21.5 46.5,32.5C 30.8333,32.5 15.1667,32.5 -0.5,32.5C -0.5,21.5 -0.5,10.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b637e",
    d: "M 40.5,4.5 C 29.1618,4.33348 17.8284,4.50014 6.5,5C 5.92206,6.41704 4.92206,7.25038 3.5,7.5C 3.51056,5.98261 4.17723,4.81595 5.5,4C 17.3407,3.17387 29.0073,3.34053 40.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#30385a",
    d: "M 40.5,4.5 C 41.1174,4.61071 41.6174,4.94404 42,5.5C 42.8461,9.56768 42.3461,13.401 40.5,17C 43.0599,21.1299 43.0599,25.1299 40.5,29C 28.8333,29.6667 17.1667,29.6667 5.5,29C 3.99288,27.5267 3.32621,25.6934 3.5,23.5C 3.68511,20.8664 4.68511,18.6997 6.5,17C 3.972,14.3772 2.972,11.2105 3.5,7.5C 4.92206,7.25038 5.92206,6.41704 6.5,5C 17.8284,4.50014 29.1618,4.33348 40.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4e5ea",
    d: "M 9.5,8.5 C 18.5,8.5 27.5,8.5 36.5,8.5C 36.666,13.8437 36.4994,19.1771 36,24.5C 27.3333,25.8333 18.6667,25.8333 10,24.5C 9.50065,19.1771 9.33398,13.8437 9.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#283154",
    d: "M 33.5,10.5 C 33.5,14.5 33.5,18.5 33.5,22.5C 26.5,22.5 19.5,22.5 12.5,22.5C 12.5,18.5 12.5,14.5 12.5,10.5C 19.5,10.5 26.5,10.5 33.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575f7b",
    d: "M 33.5,10.5 C 34.4849,14.6344 34.8182,18.9677 34.5,23.5C 26.9809,23.825 19.6476,23.4916 12.5,22.5C 19.5,22.5 26.5,22.5 33.5,22.5C 33.5,18.5 33.5,14.5 33.5,10.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.aeef05dcb38257c87c943d048a76d1ce.svg";
export { ForwardRef as ReactComponent };